// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store";
import ElementUI from 'element-ui' //element-ui的全部组件
import 'element-ui/lib/theme-chalk/index.css'//element-ui的css
Vue.use(ElementUI) //使用elementUI

import './assets/css/common.css'
import {parseTime} from "@/utils/wmeeting";

import $ from 'jquery'
import 'jquery-mousewheel';
window.$ = $;

Vue.config.productionTip = false;
Vue.prototype.$formatDate = parseTime;


/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

